import { Suspense, lazy } from "react";
import PrivateRoute from "./PrivateRoute";
const Index = lazy(() => import("../modules/organizationalStructure/Index"));

const SalesSector = lazy(() =>
  import("../modules/organizationalStructure/SalesSector")
);
const Notification = lazy(() => import("../modules/notifications/Index"));
import SaleSectorDetails from "../modules/organizationalStructure/SaleSectorDetails";
import PageLoader from "../components/PageLoader";
const Dashboard = lazy(() => import("../modules/dashboard"));

const organizationalStructureRoutes = [
  {
    path: "/dashboard",
    element: (
      <Suspense fallback={<PageLoader />}>
        <PrivateRoute>
          <Dashboard />
        </PrivateRoute>
      </Suspense>
    ),
  },
  {
    path: "/organizational-structure",
    element: (
      <Suspense fallback={<PageLoader />}>
        <PrivateRoute requiredRoles={["ADMIN", "HR"]}>
          <Index />
        </PrivateRoute>
      </Suspense>
    ),
  },
  {
    path: "/notifications",
    element: (
      <Suspense fallback={<PageLoader />}>
        <PrivateRoute>
          <Notification />
        </PrivateRoute>
      </Suspense>
    ),
  },
  {
    path: "/organizational-structure/unit-details/:id",
    element: (
      <Suspense fallback={<PageLoader />}>
        <PrivateRoute>
          <SalesSector />
        </PrivateRoute>
      </Suspense>
    ),
  },
  {
    path: "organizational-structure/job-details/:id",
    element: (
      <Suspense fallback={<PageLoader />}>
        <PrivateRoute>
          <SaleSectorDetails />
        </PrivateRoute>
      </Suspense>
    ),
  },
];
export default organizationalStructureRoutes;
